import styled from "styled-components";

export const TpvWrapper = styled.div`
  flex-grow: 1;
`;